/** Loads and exposes the platform identity independently from restaurant branding. */

import { createContext, useContext, useEffect, useState } from 'react';
import { DEFAULT_PLATFORM_BRAND } from '../../Config/platformBrand';
import { getPublicPlatformBrand } from '../../services/brand';

const PlatformBrandContext = createContext(DEFAULT_PLATFORM_BRAND);

export function PlatformBrandProvider({ children }) {
  const [platformBrand, setPlatformBrand] = useState(DEFAULT_PLATFORM_BRAND);

  useEffect(() => {
    let active = true;
    getPublicPlatformBrand()
      .then((result) => {
        if (active && result?.success && result?.data?.brand) {
          setPlatformBrand({ ...DEFAULT_PLATFORM_BRAND, ...result.data.brand });
        }
      })
      .catch(() => {
        // The local fallback keeps ordering available if the brand endpoint is unreachable.
      });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    document.title = document.title.replace(/Supu|Happen/g, platformBrand.name);
    document.documentElement.dataset.platformBrand = platformBrand.name;
  }, [platformBrand.name]);

  return (
    <PlatformBrandContext.Provider value={platformBrand}>
      {children}
    </PlatformBrandContext.Provider>
  );
}

export const usePlatformBrand = () => useContext(PlatformBrandContext);
